// TODO Use this instead of throw { validationError: true }
export default class ValidationError extends Error {
  validationError = true

  constructor() {
    super('Validation error')
  }
}
